import { Thunk } from "../store";
import { tryConnectingToDefaultPrometheus } from "./";

export const appInitThunk = (): Thunk => async (dispatch) => {
  dispatch(tryConnectingToDefaultPrometheus());
};
